export function generateUUID() {
  try {
    return crypto.randomUUID()
  } catch {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0
      const v = c === 'x' ? r : (r & 0x3) | 0x8
      return v.toString(16)
    })
  }
}

export function getSessionId() {
  const match = document.cookie.match(/(?:^|;)\s*chat_session=([^;]+)/)
  if (match) return decodeURIComponent(match[1])

  const newId = generateUUID()
  const maxAge = 30 * 24 * 60 * 60 // 30 days
  document.cookie = `chat_session=${encodeURIComponent(newId)}; max-age=${maxAge}; path=/; SameSite=Lax`
  return newId
}

export function clearSession() {
  document.cookie = 'chat_session=; max-age=0; path=/; SameSite=Lax'
}
